<template>
  <div class="container mx-auto py-6">
    <div class="bg-white rounded-lg shadow-lg p-6">
      <div class="mb-4">
        <button @click="goBack" class="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium mb-4">
          <i class="pi pi-arrow-left mr-2"></i> Kembali
        </button>
      </div>
      <div class="mb-6">
        <h2 class="text-2xl font-semibold">Daftar Sanggah (View Only)</h2>
        <p class="text-gray-600">{{ dokumenPengadaan.nama }}</p>
      </div>

      <div v-if="sanggahs.length === 0" class="text-center py-8">
        <div class="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <i class="pi pi-info-circle text-gray-500 text-4xl mb-4"></i>
          <h3 class="text-lg font-semibold text-gray-800 mb-2">Tidak Ada Sanggah</h3>
          <p class="text-gray-700">Belum ada sanggah untuk dokumen pengadaan ini.</p>
        </div>
      </div>
      
      <div v-else class="overflow-x-auto">
        <table class="min-w-full table-auto">
          <thead>
            <tr class="bg-gray-100">
              <th class="px-4 py-2 text-left">No</th>
              <th class="px-4 py-2 text-left">Penyanggah</th>
              <th class="px-4 py-2 text-left">Alasan</th>
              <th class="px-4 py-2 text-left">Status</th>
              <th class="px-4 py-2 text-left">Jawaban</th>
              <th class="px-4 py-2 text-left">Dibuat</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sanggah, index) in sanggahs" :key="sanggah.id" class="border-b">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2">{{ sanggah.penyedia }}</td>
              <td class="px-4 py-2" v-html="sanggah.alasan"></td>
              <td class="px-4 py-2">
                <span :class="{
                  'px-2 py-1 rounded text-sm': true,
                  'bg-yellow-100 text-yellow-800': sanggah.status == 'proses',
                  'bg-green-100 text-green-800': sanggah.status == 'diterima',
                  'bg-red-100 text-red-800': sanggah.status == 'ditolak'
                }">
                  {{ sanggah.status }}
                </span>
              </td>
              <td class="px-4 py-2" v-html="sanggah.jawaban || '-' "></td>
              <td class="px-4 py-2">{{ formatDate(sanggah.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { dokumenPengadaan: Object, sanggahs: Array },
  methods: {
    goBack() { window.history.length > 1 ? window.history.back() : this.$inertia.visit(route('dokumen_pengadaan.list_pengumuman_pemenang_exec')) },
    formatDate(dateString) {
      if (!dateString) return '-';
      const d = new Date(dateString)
      return d.toLocaleString('id-ID', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
</style>

